import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 11.8,
			y: 2.5,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M39.8 30.7l-2-.2.2-2.5 2 .2-.2 2.5zm-3.9-.4l-2-.2.3-2.5 2 .2-.3 2.5zm-3.9-.4l-2-.2.3-2.5 2 .2-.3 2.5zm-3.9-.5l-2-.2.3-2.5 2 .2-.3 2.5zm-3.8-.4l-2-.2.3-2.5 2 .2-.3 2.5zm-4-.5c-.7-.2-1.4-.4-2.1-.7l1-2.3 1.7.6-.6 2.4zm-4-1.8c-.6-.4-1.2-1-1.7-1.5l1.9-1.7c.4.4.8.9 1.3 1.2l-1.5 2zm-3-3.3c-.4-.6-.7-1.3-.9-2l2.3-.9c.2.6.4 1.1.8 1.6l-2.2 1.3zm-1.4-4.1c-.1-.7-.1-1.5 0-2.2l2.4.1c0 .6 0 1.3.1 1.8l-2.5.3zm2.4-4.1l-2.5-.1.1-2 2.4.1v2zm0-3.9h-2.5l.1-2h2.4v2zm0-3.9h-2.5l.1-2h2.4v2z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41.1,
			y: 29.2,
			transform: "rotate(-84.197 42.346 29.729)",
			className: "icon-fill-secondary",
			width: 2.5,
			height: 1
		})
	] }), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M42 0H3C1.3 0 0 1.3 0 3v39c0 1.7 1.3 3 3 3h39c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3zm.5 3v33l-23.1-2.6c-5.7-.7-10.1-5.5-10.1-11.3V2.5H42c.3 0 .5.2.5.5zM42 42.5H3c-.3 0-.5-.2-.5-.5V3c0-.3.2-.5.5-.5h3.8v19.6c0 7 5.3 12.9 12.3 13.8l23.4 2.7V42c0 .3-.2.5-.5.5z"
	})]
});
export default SvgIcon;
